export default __webpack_public_path__ + "static/media/media3.daf45811.png";